import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./Orders.module.css";
import axios from "axios";
import { useSelector } from "react-redux";

function Orders() {
  const [orders, setOrders] = useState([]);
  const token = useSelector((state) => state.user.info.token);
  useEffect(() => {
    const getUser = async () => {
      const response = await axios({
        url: `${process.env.REACT_APP_API_URL}/orders/user`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      setOrders(response.data);
    };
    getUser();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    // eslint-disable-next-line
  }, []);
  return (
    <div className={"container " + styles.orders_container}>
      <h1 className={styles.orders_title}>Order history</h1>
      {orders.length > 0 ? (
        <>
          <p className={styles.orders_subtitle + " m-0"}>
            Check the status of your recent orders, and discover similar
            products
          </p>
          {orders.map((order) => (
            <div key={order._id} className={styles.single_order + " mt-5"}>
              <div
                className={
                  styles.top_section + " d-flex justify-content-between"
                }
              >
                <div className="row">
                  <div
                    className="col-4 text-wrap text-break"
                    style={{ width: "10rem" }}
                  >
                    <h6>Order id</h6>
                    <p>{order._id}</p>
                  </div>
                  <div
                    className="col-4 text-wrap text-break"
                    style={{ width: "10rem" }}
                  >
                    <h6>Date placed</h6>
                    <p>
                      {new Date(order.createdAt).toLocaleDateString("es-ES")}
                    </p>
                  </div>
                  <div
                    className="col-4 text-wrap text-break"
                    style={{ width: "10rem" }}
                  ></div>
                </div>
                <div>
                  <button className={styles.btn_view_order}>
                    <Link className={styles.orders_btn_link}>View Order</Link>
                  </button>
                  <button className={styles.btn_view_invoice + " ms-2"}>
                    <Link className={styles.orders_btn_link}>View Invoice</Link>
                  </button>
                </div>
              </div>
              <ul className={styles.bottom_section + " m-0 p-0"}>
                {order.products.map((product, index) => (
                  <div key={index} className={styles.orders_single_product}>
                    <li className={styles.orders_single_product_li}>
                      <div className="d-flex justify-content-between">
                        <div>
                          <img
                            src={product.image}
                            alt=""
                            className={styles.orders_product_image + " m-0"}
                          />
                        </div>
                        <div className="d-flex flex-grow-1">
                          <div
                            className={
                              "d-flex flex-column justify-content-between"
                            }
                          >
                            <h5 className={styles.orders_product_name}>
                              {product.name}
                            </h5>
                            <p
                              className={
                                "text-break text-wrap " +
                                styles.orders_product_description
                              }
                            >
                              {product.description}
                            </p>
                          </div>
                          <p className={"flex-grow-1 text-end"}>
                            USD&nbsp;{product.price}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between mt-5">
                        <div>
                          <span>Status:</span>
                          <span className="ms-1">{order.orderStatus}</span>
                        </div>
                        <div>
                          <span className="me-2">View product</span>
                          <span>|</span>
                          <span className="ms-2">Buy again</span>
                        </div>
                      </div>
                    </li>
                  </div>
                ))}
              </ul>
              <div
                className={"d-flex justify-content-end " + styles.total_amount}
              >
                <h6 className="m-0">Total amount:</h6>
                <p className="ms-2 mb-0">USD {order.orderTotal}</p>
              </div>
            </div>
          ))}
        </>
      ) : (
        <>
          <h3 className={"mt-4 " + styles.no_orders}>
            Oops! You don't have any orders yet!
          </h3>
        </>
      )}
    </div>
  );
}

export default Orders;
